import { memo, useEffect } from 'react'

import { Debtor } from 'containers/PersonalForm/PersonalForm.interface'
import { Unit } from 'components/Input/Text'
import PathAmountInput from 'components/PathAmountInput'
import { Box } from '@mui/material'

import { getHighestRetirementPension } from './utils'
import { observer } from 'mobx-react'
import useStore from 'stores/utils/hooks/useStore'
import RCEVariantCIncomeCard from 'components/AbTestComponents/CAT4558RceVoucherBanner/RCEVariantCIncomeCard'
import ConditionalField from 'components/ConditionalField'

const RCEEditFieldDebtor = observer(
  ({ debtor = Debtor.PRIMARY, outerLabel = false, smallTextField = false }) => {
    const {
      traversal: {
        data: { debtors }
      },
      traversalSession: { setRceEditInitialData }
    } = useStore()
    const debtorKey = debtor as 'primary' | 'secondary'

    const pensions = debtors[debtorKey].income.pensions || []
    const highestPension = getHighestRetirementPension(pensions || [])

    useEffect(() => {
      setRceEditInitialData({ pension: highestPension?.income })
    }, [])

    return (
      <>
        <Box>
          <PathAmountInput
            path={`debtors.${debtor}.income.primary`}
            unit={Unit.EURO_MONTH}
            showTooltipOnFieldClick={false}
            touchIgnored
            outerLabel={outerLabel}
            smallTextField={smallTextField}
            isTooltipHidden={true}
          />
          {debtor === Debtor.PRIMARY && <RCEVariantCIncomeCard />}
          <ConditionalField path={`debtors.${debtor}.income.pensions`}>
            <PathAmountInput
              path={`debtors.${debtor}.income.pensions.${[highestPension.index]}.income`}
              unit={Unit.EURO_MONTH}
              showTooltipOnFieldClick={false}
              touchIgnored
              label="Rente (netto)"
              defaultValue={highestPension.income}
              outerLabel={outerLabel}
              smallTextField={smallTextField}
              isTooltipHidden={true}
            />
          </ConditionalField>
        </Box>
      </>
    )
  }
)

export default memo(RCEEditFieldDebtor)
